export const canShowEstateRegistrationEdit = (
  status?: string | null
): boolean =>
  status === 'ACTIVE' ||
  status === 'REGISTRATION_PENDING' ||
  status === 'REGISTRATION_INCOMPLETE' ||
  status === 'BIOMETRY_PENDING' ||
  status === 'BIOMETRY_REJECTED';
